import React, { useState } from 'react';
import parse from 'html-react-parser';

import {
	DescriptionContainer,
	DescriptionInner,
	TextToggle,
	ToggleContainer,
} from './descriptionStyles';

type descriptionProps = {
	text: string;
};

const Description: React.FC<descriptionProps> = ({ text }) => {
	// TODO: Swap for just using short description - helps to ensure beginning paragraph
	const textLength = text.split('\n').length;
	const firstElement = parse(text.split('\n')[0]);
	const parsedText = parse(text);
	const [descriptionText, setDescriptionText] = useState(firstElement);
	const [descriptionOpen, setDescriptionOpen] = useState(false);

	const handleTextToggle = (e: any) => {
		e.preventDefault();
		if (descriptionOpen) {
			console.log('closing');
			setDescriptionText(firstElement);
			setDescriptionOpen(false);
		} else {
			console.log('opening');
			setDescriptionText(parsedText);
			setDescriptionOpen(true);
		}
	};

	return (
		<>
			{/* TODO: is parsing this wise? */}
			<DescriptionContainer>
				<DescriptionInner>{descriptionText}</DescriptionInner>

				{textLength > 2 && (
					<ToggleContainer>
						<TextToggle
							onClick={(e: any) => {
								handleTextToggle(e);
							}}>
							Show {descriptionOpen ? 'less' : 'more'}
						</TextToggle>
					</ToggleContainer>
				)}
			</DescriptionContainer>
		</>
	);
};

export default Description;
